/* eslint-disable import/no-mutable-exports */
const env = process.env.REACT_APP_ENV;

let envValues = {
  PORT: 80,
  REACT_APP_API_ENDPOINT: 'http://localhost:4075/v1/admin',
  REACT_APP_APP_API_ENDPOINT: 'http://localhost:4075/v1/app',
  REACT_APP_API_FRONT_END: 'http://localhost:4075',
  REACT_APP_API_PERMISSION_DENIED: 'http://localhost:4075/permission',
  REACT_APP_SHOW_COOKIE_BOX: false,
  SOCKET_STATUS: 'OFF',
  COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
  S3_BASE_URL: 'https://ucollabit-staging.s3.us-west-2.amazonaws.com/',
  S3_CDN_URL: 'https://dcoe57aydj9ut.cloudfront.net',
};

switch (env) {
  case 'staging':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api-ucollabit.iscriptsdemo.com/v1/admin',
      REACT_APP_APP_API_ENDPOINT: 'https://api-ucollabit.iscriptsdemo.com/v1/app',
      REACT_APP_API_FRONT_END: 'https://manage-ucollabit.iscriptsdemo.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://manage-ucollabit.iscriptsdemo.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_BASE_URL: 'https://ucollabit-staging.s3.us-west-2.amazonaws.com/',
      S3_CDN_URL: 'https://dcoe57aydj9ut.cloudfront.net',
    };
    break;
  case 'production':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api.ucollabit.com/v1/admin',
      REACT_APP_APP_API_ENDPOINT: 'https://api.ucollabit.com/v1/app',
      REACT_APP_API_FRONT_END: 'https://api.ucollabit.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://api.ucollabit.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_BASE_URL: 'https://ucollabit-bucket.s3.us-east-2.amazonaws.com/',
      S3_CDN_URL: 'https://d20pg774jkw2is.cloudfront.net',
    };
    break;
  case 'development':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'http://localhost:4075/v1/admin',
      REACT_APP_APP_API_ENDPOINT: 'http://localhost:4075/v1/app',
      REACT_APP_API_FRONT_END: 'http://localhost:3000',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_BASE_URL: 'https://ucollabit-staging.s3.us-west-2.amazonaws.com/',
      S3_CDN_URL: 'https://dcoe57aydj9ut.cloudfront.net',
    };
    break;
  default:
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'http://localhost:4075/v1/admin',
      REACT_APP_APP_API_ENDPOINT: 'http://localhost:4075/v1/app',
      REACT_APP_API_FRONT_END: 'http://localhost:3000',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_BASE_URL: 'https://ucollabit-staging.s3.us-west-2.amazonaws.com/',
      S3_CDN_URL: 'https://dcoe57aydj9ut.cloudfront.net',
    };
    break;
}

export default envValues;
